import React from 'react';

import { l10n } from '@ott/l10n';
import Button from '@ott/button';
import Modal from '@ott/modal';
import CheckIconSmall from '@ott/icon-small-check';

import styles from './MetaModal.scss';

const MODAL_CONTENT_OPTIONS = {
  className: styles.content,
  childrenClassNames: {
    closer: styles.closer,
  },
};

type Props = {
  onClose: VoidFunction;
  onAction: VoidFunction;
};

const MetaModal = ({ onClose, onAction }: Props) => {
  return (
    <Modal isOpen={true} contentOptions={MODAL_CONTENT_OPTIONS} onClose={onClose}>
      <div
        className={styles.wrapper}
        id="virtual-card-release-promo"
        data-locator="virtual-card-release-promo"
      >
        <div className={styles.card} />
        <div className={styles.inner}>
          <div className={styles.title}>{l10n('virtualCard.metaPromo.title')}</div>
          <div className={styles.description}>{l10n('virtualCard.metaPromo.description')}</div>
          <div className={styles.options}>
            <div>
              <div className={styles.option}>
                <div className={styles.optionIcon}>
                  <CheckIconSmall />
                </div>
                <div className={styles.optionText}>
                  {l10n('virtualCard.metaPromo.options.speed')}
                </div>
              </div>
              <div className={styles.option}>
                <div className={styles.optionIcon}>
                  <CheckIconSmall />
                </div>
                <div className={styles.optionText}>
                  {l10n('virtualCard.metaPromo.options.price')}
                </div>
              </div>
              <div className={styles.option}>
                <div className={styles.optionIcon}>
                  <CheckIconSmall />
                </div>
                <div className={styles.optionText}>
                  {l10n('virtualCard.metaPromo.options.cashback')}
                </div>
              </div>
            </div>
          </div>
          <Button
            onClick={onAction}
            className={styles.button}
            withFullWidth={true}
            specificLocators="virtual-card-release-button"
          >
            {l10n('virtualCard.metaPromo.action')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MetaModal;
